import { GET_CHECK_URL } from 'app-constants';
import { AxiosRequestConfig } from 'axios';
import { apiServer } from 'settings/web-services/api';

export function checkUrl(cfg: AxiosRequestConfig) {
  return apiServer.get(GET_CHECK_URL, cfg);
}
